let module = angular.module('app.resources');

module.factory('SRTSource', function SRTSource($resource) {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/srt_sources/:id`,
    { id: '@id' },
    {
      query: {
        method: 'GET',
        isArray: true,
      },
      update: {
        method: 'PUT',
      },
      create: {
        method: 'POST',
      },
      delete: {
        method: 'DELETE',
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/srt-source.js